<template>
  <fetch-worm-base key="wormbase" :id="wb_id">
    <template slot-scope="{response, loading}">
      <div v-if="loading">Loading...</div>
      <div v-else-if="Object.keys(response).length > 0">
        {{ goto(response.gene_name) }}
      </div>
      <div v-else>
        No record
      </div>
    </template>
  </fetch-worm-base>
</template>

<script>
import FetchWormBase from "@/components/EMBD/FetchWormBase";

export default {
  components: {
    FetchWormBase,
  },
  name: "WormBase",
  data() {
    return {
      wb_id: this.$route.params.wb_id,
    }
  },
  methods: {
    goto(gene_name) {
      const vm = this
      vm.$router.push({ name: 'item_view', params: {id: gene_name} });
      setTimeout(() => {
        vm.$router.go();
      }, 200);
    }
  }
}
</script>

<style scoped>

</style>